import {$controller} from "rapid/index";
import {delay, clone} from "lodash";
import SecretIdDialogController from "../../secretid/secretid-controller";
import SecretIdDialogTemplate from "../../secretid/secretid.html";
import {DeploymentCreateController} from "../deployment-create/deployment-create";
import DeploymentCreateTemplate from "../deployment-create/deployment-create.html";

import {DeploymentApplyController} from "../deployment-apply/deployment-apply";
import DeploymentApplyTemplate from "../deployment-apply/deployment-apply.html";
import {DeleteDialogController} from "../../common/delete-dialog/delete-dialog";
import DeleteDialogTemplate from "../../common/delete-dialog/delete-dialog.html";
const dependencies = ["$Company", "$Deployment", "$Configuration", "$companies", "gettextCatalog", "$mdEditDialog"];

export default class Controller extends $controller {

    constructor($injector, $scope, $state, $stateParams, $auth, $window, $ToastService, $UndoDeleteService) {
        "ngInject";
        super($injector, dependencies);
        this.$scope = $scope;
        this.$state = $state;
        this.$auth = $auth;
        this.$window = $window;
        this.$scope.loading = true;
        this.$scope.query = {page: 1, search: ""};
        this.$scope.filter = {};
        this.$scope.deployments = [];
        this.$scope.pageCount = 0;
        this.$scope.canAddMore = true;
        this.$stateParams = $stateParams;
        this.toastService = $ToastService;
        this.undoDelete = $UndoDeleteService;
        this.$scope.logOrder = () => {
            this.$scope.query.ordering = this.$scope.query.order.replace("_", "");
            this.query(true);
        };

        this.logisticsType = {
            "by_upreach": "By UpReach",
            "by_client": "By Client"
        };

        this.status = {
            "draft": "Draft",
            "booked": "Booked",
            "delivery": "Delivery",
            "active": "Active",
            "done": "Done"
        };

        this.searchByKeyPress = (event) => {
            const keyName = event.key;
            const letters = "abcdefghijklmnopqrstuvwxyz";
            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
                this.$scope.$apply(() => {
                    this.$scope.filter.show = true;
                    if (!this.$scope.query.search) {
                        this.$scope.query.search = keyName;
                    }
                });
                delay(() => {
                    document.getElementById("search-field").focus();
                }, 100);
            }
        };

    }

    $onInit() {
        this.$scope.filter.show = false;
        this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
        this.checkIfFromDropbox();
        document.addEventListener("keypress", this.searchByKeyPress);
    }

    $onDestroy() {
        document.removeEventListener("keypress", this.searchByKeyPress);

    }

    query(isNew) {
        this.$scope.query.page = isNew ? 1 : this.$scope.query.page;
        this.$scope.loading = true;

        var deployments = this.$Deployment.query(this.$scope.query);

        Promise.all([deployments.$promise]).then(() => {
            this.$scope.query.page = deployments._meta.page || 1;
            this.$scope.loading = false;

            isNew ? this.$scope.deployments = deployments : this.$scope.deployments.push(...deployments);
            this.$scope.pageCount = deployments._meta.page_count;
            this.$scope.canAddMore = this.$scope.query.page !== this.$scope.pageCount;

            this.$scope.$apply();
        });
    }

    addMoreItems() {
        this.$scope.query.page++;
        this.query();
    }

    checkIfFromDropbox() {
        if (this.$stateParams && this.$stateParams.code && localStorage.getItem("dropboxDeployment")) {
            let d = localStorage.getItem("dropboxDeployment");
            d = JSON.parse(d);
            this.$state.go("deployments.update", {cid: this.$filter("getObjectId")(d.url), code: this.$stateParams.code});
        } else {
            localStorage.removeItem("dropboxDeployment");
        }
    }

    onQueryFilterChange() {
        this.$scope.query.page = 1;
        const newValue = clone(this.$scope.query.search);
        this.$scope.loading = true;
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.$scope.query.search);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.query(true);

            }
        }, 500);
    }

    addNew(event, sourceDeployment=null) {
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: this.gettext("Create new deployment"),
            controller: DeploymentCreateController,
            template: DeploymentCreateTemplate,
            targetEvent: event,
            locals: {
                callback: (deployment) => { this.createDeployment(deployment); },
                userCompany: this.$companies.getCached(),
                sourceDeployment: sourceDeployment
            }
        });
    }

    createDeployment(configuration) {
        let deployment = this.$Deployment.create(configuration);
        deployment.$promise
            .then(() => this.$scope.deployments.unshift(deployment))
            .then(() => {
                    this.$state.go("deployments.update", {cid: this.$filter("getObjectId")(deployment.url), isNew: true});
                });
    }

    showSecretID(ev, item) {
        var parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Set/Share Deployment ID",
            controller: SecretIdDialogController,
            template: SecretIdDialogTemplate,
            targetEvent: ev,
            escapeToClose: false,
            locals: {
                selectedItem: item,
                secretKind: this.gettextCatalog.getString("Deployment")
            }
        });
    }

    editName(ev, item) {
        if (["md-icon", "button"].indexOf(ev.target.tagName.toLowerCase()) < 0)
            return; // workaround for editDialog requirement - currentTarget = table cell.

        ev.stopPropagation();

        let editDialog = {
            modelValue: item.name,
            placeholder: this.gettextCatalog.getString("Enter new name"),
            save: (input) => {
                item.name = input.$modelValue;
                item.$update().then(() => {
                    this.toastService.showSimple(`Saved new deployment name "${item.name}".`, 5000);
                }).catch(() => {
                    this.toastService.showError(`Could not save new deployment name "${item.name}".`);
                });
            },
            targetEvent: ev,
            title: this.gettextCatalog.getString("Enter new name"),
            validators: {
                "md-maxlength": 50
            }
        };

        this.$mdEditDialog.small(editDialog).then((...args) => {
            console.log("$mdEditDialog promise resolved with args: ", args);
        });
    }

    applyDeployment(ev, item) {
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: this.gettext("Apply deployment on device"),
            controller: DeploymentApplyController,
            template: DeploymentApplyTemplate,
            targetEvent: ev,
            locals: {
                callback: (deployment) => { this.sendDeployment(deployment); },
                deployment: item,
                hasBooth: !!item.booth_id
            }
        });
    }

    sendDeployment(item) {
        let title = "";
        let text = "";
        let button = "";

        if (item.move.status && !item.replace.status) {
            title = "Move deployment?";
            text = `This will remove “${item.move.target}” and its Configurations from ${item.move.from} and install it on ${item.move.to}.`;
            button = "MOVE";
        } else if (item.replace.status && !item.move.status) {
            title = "Replace deployment?";
            text = `This will remove “${item.replace.from}” and its Configurations from ${item.replace.target} and install “${item.replace.to}” instead.`;
            button = "REPLACE";
        } else if (item.replace.status && item.move.status) {
            title = "Move & replace Deployment?";
            text = `This will remove “${item.replace.from}” and its Configurations from ${item.move.to}, then remove “${item.target}” and its Configurations from ${item.move.from} and install it on ${item.move.to}.`;
            button = " MOVE & REPLACE";
        } else {
            title = "Apply deployment?";
            text = `This will apply “${item.target}” and its Configurations on ${item.req.booth_id}.`;
            button = "APPLY";
        }
        let confirm = this.$mdDialog.confirm()
            .title(title)
            .textContent(text)
            .ariaLabel("Deployment")
            .ok(button)
            .cancel("CANCEL");

        this.$mdDialog.show(confirm).then(() => {
            this.$auth.$http({
                url: "/api/booth-set-deployment/",
                method: "PUT",
                data: item.req
            }).then(() => {
                this.toastService.showSimple(`Deployment installed!`, 5000);
                this.$state.go("auth.signin");
            }).catch((resp) => {
                resp.data.detail ? this.toastService.showError(`Can't install deployment.` + resp.data.detail, 5000) :
                this.toastService.showError(`Can't install deployment. Booth is not online or has current deployment!`, 5000);
            });
        });
    }

    openDeleteDialog(ev, item) {
        this.$mdDialog.show({
            title: "Deployment Delete",
            controller: DeleteDialogController,
            template: DeleteDialogTemplate,
            targetEvent: event,
            locals: {
                callback: () => {
                    this.deleteItem(ev, item);
                },
                target: "deployment",
                item: item
            }
        });
    }

    deleteItem(ev, item) {
        item.$delete().then(() => {
            this.toastService.deleteToast(`\`Deleted deployment "${item.name}".`, () => {
                this.undoDelete.undoDelete("deployments", this.$filter("getObjectId")(item.url)).then(() => {
                    this.toastService.showSimple(`Deletion undone`, 5000);
                    this.query(true);
                }).catch(() => {
                    this.toastService.showError(`Could not undone deletion`, 5000);
                });
            });
            this.query(true);
        }).catch(() => {
            this.toastService.showError(`Could not delete deployment "${item.name}".`, 30000);
        });
    }

    removeFilter () {
        this.$scope.filter.show = false;
        this.$scope.query.search = "";
    }

    showFilter() {
        this.$scope.filter.show = true;
        delay(() => {
            document.getElementById("search-field").focus();
        }, 100);

    }

    changeActiveConfig(value, item) {
        value = value || [];
        item.$update().then(() => {
            this.query(true);
        }).catch(() => {
            this.toastService.showError(`Could not update deployment "${item.name}".`, 5000);
        });
    }
    changeCompany(value, item) {
        if (value && value.length) {
            item.$update().then(() => {
                this.query(true);
            }).catch(() => {
                this.toastService.showError(`Could not update deployment "${item.name}".`, 5000);
            });
        }
    }

    onSearchBlur() {
        if (!this.$scope.query.search) {
            this.$scope.filter.show = false;
        }
    }

    isClient() {
        return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
    }

    openInNewTab(id) {
        this.$window.open(this.$window.location.href + "setting/" + id, "_blank");
    }
    removeDeployment(item) {
        let confirm = this.$mdDialog.confirm()
            .title("Remove Deployment?")
            .textContent(`This will remove “${item.name}” and all its Configurations from ${item.booth_id}. It will remain in the 
            UpReach Cloud and can be downloaded again any time.`)
            .ariaLabel("Deployment")
            .ok("REMOVE")
            .cancel("CANCEL");

        this.$mdDialog.show(confirm).then(() => {
            this.$auth.$http({
                url: "/api/booth-remove-deployment/",
                method: "PUT",
                data: {deployment_url: item.url, booth_id: item.booth_id }
            }).then(() => {
                this.query(true);
                this.toastService.showSimple(`Deployment removed`, 5000);
            }).catch(() => {
                this.toastService.showError(`Can't remove deployment!`, 5000);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./sources/components/deployments/deployment-list/deployment-list.controller.js